export default __webpack_public_path__ + "static/media/UCityProWeb-Regular.61668b9d.woff";